module.exports = __webpack_public_path__ + "static/media/news-03.ec1330a0.jpg";